import { render } from "./HeroiconsSolidPlusCircle.vue?vue&type=template&id=263948aa"
const script = {}

import exportComponent from "/Users/nazikban/projects/credit-west-second/packages/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidPlusCircle.vue"]])

export default __exports__